import {
  applySnapshot,
  Instance,
  SnapshotIn,
  SnapshotOut,
  flow,
  types,
  getRoot,
  destroy,
  getParent,
  detach,
  clone,
} from 'mobx-state-tree';

import createStore from 'widgets/lib/create-store';
import { browser, debug, storage, utils } from 'lib';
import { RtcType } from 'widgets/lib/rtc/rtc-base';

const log = debug.create('rtcStore');

const defaultState = {
  isLogin: false,
  isPortrait: false,
  isPreviewed: false,
  isPublishingStream: false,
  isInitMusicInstance: false,
};

const EngineModel = types.model('EngineModel', defaultState).actions((self) => {
  return {
    updatePreviewed: (status: boolean) => {
      self.isPreviewed = status;
    },
    updatePublishingStream: (status: boolean) => {
      self.isPublishingStream = status;
    },
    updateIsPortrait: (isPortrait: boolean) => {
      self.isPortrait = isPortrait;
    },
  };
});

const RtcModel = types
  .model('RtcModel', {
    // rtcType: 'zego',
    // rtcType: 'agora',
    rtcType: '', // zego | agora
    streamType: '',
    zego: types.optional(EngineModel, {}),
    agora: types.optional(EngineModel, {}),
  })
  .views((self) => {
    return {
      // 当前rtc信息
      get currentRtcInfo() {
        return self[self.rtcType] || {};
      },
      get htmlClass() {
        if (browser.memeClient) {
          if (self.rtcType == 'agora') {
            return '_AgoraClient';
          } else {
            return '_ZegoClient';
          }
        } else {
          if (self.rtcType == 'agora') {
            return '_AgoraWeb';
          } else {
            return '_ZegoWeb';
          }
        }
      },
    };
  })
  .actions((self) => {
    return {
      setRtcType(rtcType: number | string) {
        if (typeof rtcType === 'string') {
          self.rtcType = rtcType;
        } else {
          self.rtcType =
            {
              5: 'zego',
              9: 'agora',
            }[rtcType] ?? '';
        }
      },
      updateStreamType: (type: string) => {
        self.streamType = type;
      },
      updateLogin(status: boolean) {
        self.currentRtcInfo.isLogin = status;
      },
      resetRtcZego: () => {
        self.zego = defaultState as any;
      },
      resetRtcAgora: () => {
        self.agora = defaultState as any;
      },
    };
  });

const initState = {};

interface IRtcModel extends Instance<typeof RtcModel> {}

const { store, Provider, useStore, withStore } = createStore(
  RtcModel,
  initState,
);

const getRtcStore = () => {
  return store;
};

export {
  store as rtcStore,
  Provider,
  useStore as useRtcStore,
  getRtcStore,
  withStore as withRtcStore,
};
